import { keys, values, zipObject } from 'lodash-es';

export type MaybePromise<T> = T | Promise<T>;

export async function allValues<
    T extends {
        [s: string]: unknown;
    },
>(object: T): Promise<{ [P in keyof T]: Awaited<T[P]> }> {
    return zipObject(
        keys(object),
        await Promise.all(values(object)),
    ) as unknown as Promise<{
        [P in keyof T]: Awaited<T[P]>;
    }>;
}
